/**
 * Canonical event names for PanLuma product analytics.
 *
 * Keep this list small and curated — per-module funnels should add events here
 * (or import EventName) rather than passing freeform strings to `capture`. The
 * taxonomy doc at `docs/platform/product-analytics.md` is the source of truth
 * for what each event means and when to fire it.
 */

export const AnalyticsEvent = {
  // Lifecycle
  SignupCompleted: 'signup_completed',
  TenantSetupCompleted: 'tenant_setup_completed',
  Onboarded: 'user_onboarded',

  // Cross-module activation
  FirstEntityCreated: 'first_entity_created',

  // AI / agents (also emitted server-side; see analytics_service.py)
  AgentRunCompleted: 'agent_run_completed',
  AiChatMessageSent: 'ai_chat_message_sent',

  // Mobile shell health. Fired when an OTA bundle is refused because the device's
  // native binary is below the bundle's min-native floor — i.e. this install can
  // no longer receive web updates and is stuck until it is updated from the store.
  // Silent before this event existed: production Android sat a full minor version
  // below the floor for five weeks and the only signal was a user reporting a
  // blank screen. See docs/platform/mobile-offline-cold-start.md.
  OtaBlockedByNativeFloor: 'ota_blocked_by_native_floor',
} as const;

export type AnalyticsEventName =
  (typeof AnalyticsEvent)[keyof typeof AnalyticsEvent];
